// services/apiSlice.js or wherever your API slice is defined
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: ({pageNumber = 1, pageSize = 5, search}) => ({
        url: `/WebAuth/GetAllUsers`,
        params: { pageNumber, pageSize, search },
      }),
    }),
    getUser: builder.query({
      query: ({id}) => ({
        url: `/WebAuth/GetUser`,
        method: "Get",
        params: { id },
      }),
    }),
    deleteUser: builder.mutation({
      query: ({id}) => ({
        url: '/WebAuth/DeleteUser',
        method: "Post",
        params: {id},
      })
    }),
    blockUser: builder.mutation({
      query: ({id}) => ({
        url: '/WebAuth/BlockUser',
        method: "Post",
        params: {id},
      })
    }),
    unblockUser: builder.mutation({
      query: ({id}) => ({
        url: '/WebAuth/UnBlockUser',
        method: "Post",
        params: {id},
      })
    }),
    createTutor: builder.mutation({
      query: ({ ProfilePicture, ...queryParams }) => {
        const formData = new FormData();
        formData.append("ProfilePicture", ProfilePicture); // ProfilePicture should be a File object
    
        return {
          url: "/WebTutor/CreateTutor",
          method: "POST",
          params: queryParams, // { Name, Gender, Email, ... }
          body: formData,
        };
      },
    }),    
    getAllTutors: builder.query({
      query: ({PageNumber = 1, take = 5, search}) => ({
        url: `/WebTutor/GetAllTutors`,
        method: "Get",
        params: {PageNumber, take, search}
      }),
    }),
    getTutor: builder.query({
      query: ({id}) => ({
        url: `/WebTutor/GetTutor`,
        method: "Get",
        params: {id}
      }),
    }),
    updateTutor: builder.mutation({
      query: ({ ProfilePicture, ...queryParams }) => {
        const formData = new FormData();
        formData.append("ProfilePicture", ProfilePicture); // ProfilePicture should be a File object
    
        return {
          url: "/WebTutor/UpdateTutor",
          method: "POST",
          params: queryParams, // { Name, Gender, Email, ... }
          body: formData,
        };
      },
    }),
    deleteTutor: builder.mutation({
      query: ({id}) => ({
        url: '/WebTutor/DeleteTutor',
        method: "Post",
        params: {id},
      })
    }),
    deactivateTutor: builder.mutation({
      query: ({id}) => ({
        url: '/WebTutor/DeactivateTutor',
        method: "Post",
        params: {id},
      })
    }),
    reactivateTutor: builder.mutation({
      query: ({id}) => ({
        url: '/WebTutor/ReactivateTutor',
        method: "Post",
        params: {id},
      })
    }),
    getAllAdmins: builder.query({
      query: () => ({
        url: `/WebAdmin/GetAllAdmin?PageNumber=1&Take=10`,
        method: "Get",
      }),
    }),
    getAdminDashboard: builder.query({
      query: ({ pageNumber = 1, pageSize = 10, search = '', filter = '' }) => ({
        url: `/WebAdmin/GetAdminDashboardAsync`,
        method: "Get",
        params: {pageNumber, pageSize, search, filter}
      })
    }),
    getLineChartData: builder.query({
      query: ({ pageNumber = 1, pageSize = 10 }) => ({
        url: `/WebAdmin/GetLineChartData`,
        method: "GET",
        params: { pageNumber, pageSize },
      }),
    }),
    getAllAdminNotifications: builder.query({
      query: ({ pageNumber = 1, pageSize = 10 }) => ({
        url: `/WebAdmin/GetAllAdminNotification`,
        method: "GET",
        params: { pageNumber, pageSize },
      }),
    }),
    getAllBillingDetails: builder.query({
      query: ({ pageNumber = 1, pageSize = 10, search = "" }) => ({
        url: `/WebAdmin/GetAllBillingDetails`,
        method: "GET",
        params: { pageNumber, pageSize, search },
    }),
  }),
  }),
});

export const { 
  useLazyGetAllUsersQuery,
  useGetUserQuery, 
  useDeleteUserMutation, 
  useCreateTutorMutation, 
  useUpdateTutorMutation,
  useGetAllAdminsQuery,
  useLazyGetAllTutorsQuery,
  useGetTutorQuery,
  useDeleteTutorMutation,
  useDeactivateTutorMutation,
  useReactivateTutorMutation,
  useBlockUserMutation,
  useUnblockUserMutation,
  useGetAdminDashboardQuery,
  useGetLineChartDataQuery,
  useGetAllAdminNotificationsQuery,
  useGetAllBillingDetailsQuery
} = userApi;